// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__bsY8B","right":"Footer_right__aF09c","buttons":"Footer_buttons__21mr6"};